export default __webpack_public_path__ + "static/SSSpyView_screenshot-4@2x-aaf48a7344bff95b35b840b87fb49a97.jpg";